var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.117,
    height: 14.986,
    viewBox: "0 0 15.117 14.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.08,11.028l-5.045,5.045a1.407,1.407,0,0,1-1.991,0L3,10.036V3h7.036L16.08,9.044A1.407,1.407,0,0,1,16.08,11.028Z",
    fill: "none",
    stroke: "#fd6c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,10.5h0",
    transform: "translate(-3.982 -3.982)",
    fill: "none",
    stroke: "#fd6c50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagOrange);
export default __webpack_public_path__ + "static/media/tag_orange.eb1c7eeb6724ab8cf484ec1036a88e3a.svg";
export { ForwardRef as ReactComponent };